const allBrands = [
  {
    name: 'Volkswagen',
    value: 'vwpkw',
    urlValue: 'volkswagen',
  },
  {
    name: 'Volkswagen Bedrijfswagens',
    value: 'vwlkw',
    urlValue: 'vwbedrijfswagens',
  },
  {
    name: 'Seat',
    value: 'seat',
    urlValue: 'seat',
  },
  {
    name: 'Skoda',
    value: 'skoda',
    urlValue: 'skoda',
  },
  {
    name: 'Audi',
    value: 'audi',
    urlValue: 'audi',
  },
  {
    name: 'Cupra',
    value: 'cupra',
    urlValue: 'cupra',
  },
]

export default allBrands
